module.exports = __webpack_public_path__ + "6de23cd9fc6dd5a8e99d9b9f82a7fb27.MP3";